<template>
  <div class="container-fluid">
    <!-- Bread-crumb-->
    <div class="block-header">
      <bread-crumb :breadCrumbIteams="breadCrumbIteams"></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card card-top-line">
          <!-- Header -->
          <div class="header d-flex justify-content-between align-items-center">
            <h2>Bin List</h2>
            <!-- Right-aligned action buttons -->
            <div class="ml-auto d-flex">
              <b-button v-if="$store.getters['authpermission/hasAnyPermission'](['bin.download'])"
                variant="outline-primary"
                size="sm"
                class="mr-2"
                @click="downloadCsv"
              >
                Download CSV
              </b-button>
              <b-button variant="primary" size="sm" @click="showAddBinModal" v-if="$store.getters['authpermission/hasAnyPermission'](['bin.create'])">
                Add Bin
              </b-button>
            </div>
          </div>
          <div class="body pt-0">
            <!-- Filters/Buttons -->
            <div
              class="chart-top-action d-lg-flex justify-content-end py-3 fresh-customer-filter"
            >
              <!-- SearchBox Filters -->
              <div class="mr-0 mr-lg-3 action-top-search">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Keywords"
                    aria-label="Search"
                    v-model="search_keywords"
                    v-on:keyup.enter="searchBin"
                    aria-describedby="search-transactions"
                  />
                  <div class="input-group-append" @click="searchBin()">
                    <span class="input-group-text" id="search-mail">
                      <i class="icon-magnifier"></i>
                    </span>
                  </div>
                </div>
              </div>
              <!-- Toggle Filter Button -->
              <div class="fliter-main mr-auto mt-3 mt-lg-0">
                <b-button
                  class="fliter-btn btn-lg btn-mw"
                  :variant="isVisibleFilter ? 'primary' : 'outline-primary'"
                  @click="openFilters()"
                >
                  Filters
                  <i class="fa fa-filter" aria-hidden="true"></i>
                </b-button>
              </div>
              <b-collapse
                id="fliter-collapse"
                class="fliter-collapse"
                v-model="isVisibleFilter"
              >
                <div
                  class="d-flex flex-column justify-content-between pt-3 pr-3 pl-3 middleware-list-wrapper"
                >
                  <div
                    v-for="(item, index) in advanceFilters"
                    :key="index"
                    class="d-flex middleware-list"
                  >
                    <div class="form-group form-select single-multiselect m-0 column-1">
                      <span class="float-label w-100">
                        <label>Select Field</label>
                        <multiselect
                          placeholder=""
                          v-model="item.field"
                          :show-labels="false"
                          :options="filterField"
                          label="name"
                          :searchable="true"
                          :allowEmpty="false"
                          @select="fieldsUpdate"
                        ></multiselect>
                      </span>
                    </div>
                    <div
                      class="form-group m-0 column-2"
                      v-if="
                        item.field &&
                        (item.field.id === 'scheme' ||
                          item.field.id === 'type' ||
                          item.field.id === 'level')
                      "
                    >
                      <input
                        class="form-control"
                        type="text"
                        v-model="item.search"
                        :placeholder="'Enter ' + item.field.name"
                      />
                    </div>
                    <div
                      class="form-group m-0 column-2"
                      v-if="item.field && item.field.id === 'is_whitelisted'"
                    >
                      <select class="form-control" v-model="item.search">
                        <option value="">Select</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                    <div v-if="advanceFilters.length > 1" class="column-3">
                      <b-button
                        class="fliter-btn btn-lg"
                        variant="outline-danger"
                        @click="removeFilter(index)"
                      >
                        <i class="fa fa-times" aria-hidden="true"></i>
                      </b-button>
                    </div>
                  </div>
                  <div class="text-left">
                    <b-button
                      class="fliter-btn w-auto"
                      variant="outline-primary"
                      @click="appendFilter"
                    >
                      <i class="fa fa-plus" aria-hidden="true"></i>
                      Add more filters
                    </b-button>
                  </div>
                </div>
                <div class="pb-3 pr-3 text-right">
                  <button class="btn btn-primary w-auto" @click="applyTestfilter">
                    Apply
                  </button>
                  <button
                    class="btn btn-outline-danger w-auto ml-3"
                    @click="clearALLfilter"
                  >
                    Cancel/Clear
                  </button>
                </div>
              </b-collapse>
            </div>
            <!-- Filter Pills -->
            <div
              class="filter-list-area d-flex flex-wrap align-items-center mb-1"
              v-if="displayFilters && displayFilters.length > 0"
            >
              <i class="fa fa-filter text-primary mr-1 mb-2" aria-hidden="true"></i>
              <div class="mb-1" v-for="(item, index) in displayFilters" :key="index">
                <label
                  class="font-14 line-height-18 mb-0 ml-2"
                  v-if="
                    index === 0 ||
                    item.filter_field !== displayFilters[index - 1].filter_field
                  "
                >
                  {{ item.field_name + ":" }}
                </label>
                <!-- Generic badge for bin filters -->
                <span class="badge badge-warning-solid">
                  {{ item.filter_value ? item.filter_value : "-" }}
                  <i
                    class="fa fa-close cursor-pointer ml-1"
                    @click="removeDisplayFilter(index)"
                  ></i>
                </span>
              </div>
              <span class="text-danger cursor-pointer" @click="clearALLfilter">
                Clear all
              </span>
            </div>
            <!-- Table Pagination -->
            <div class="py-1 align-items-center justify-content-end table-pagination">
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <!-- Table -->
            <b-table
              responsive
              table-class="mb-0 table-custom border"
              head-variant="light"
              :items="typeof items === 'array' || typeof items === 'object' ? items : []"
              :fields="fields"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              @sort-changed="onSortChanged"
              striped
              show-empty
            >
              <template #cell(whitelisted)="data">
                <span
                  :class="{
                    'text-success': data.value === 'Yes',
                    'text-danger': data.value === 'No',
                  }"
                >
                  {{ data.value }}
                </span>
              </template>
              <template #cell(level1)="data">
                {{ data.value.substring(0, 19) }}
                <span v-if="data.value.length > 19">...</span>
              </template>
              <template #cell(bankName)="data">
                {{ data.value.substring(0, 19) }}
                <span v-if="data.value.length > 19">...</span>
                <i
                  class="fa fa-copy"
                  v-if="data.value != '-' && data.value != ''"
                  @click="copyText(data.value, 'Bank Name')"
                ></i>
              </template>
              <template #cell(action)="data">
                <b-dropdown
                  id="dropdown-action"
                  text="Actions"
                  right
                  variant="outline-primary"
                  size="sm"
                >
                  <template v-if="$store.getters['authpermission/hasAnyPermission'](['bin.edit'])">
                    <b-dropdown-item @click="editBin(data.item)"> Edit </b-dropdown-item>
                  </template>
                  <template v-if="$store.getters['authpermission/hasAnyPermission'](['bin.delete'])">
                    <b-dropdown-item @click="deleteBin(data.item)">
                      Delete
                    </b-dropdown-item>
                  </template>
                </b-dropdown>
              </template>
            </b-table>
            <div
              class="d-flex py-3 align-items-center justify-content-between table-pagination"
            >
              <div class="per-page">
                <b-form-group label="Per page" label-for="per-page-select" class="mb-0">
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Add/Edit Bin Modal -->
    <b-modal
      id="add-bin-modal"
      v-model="showAddBin"
      :title="modaltitle"
      size="lg"
      hide-footer
      no-close-on-backdrop
      @hidden="resetForm"
    >
      <ValidationObserver v-slot="{ passes }">
        <form @submit.prevent="passes(submitForm)" autocomplete="off">
          <div class="row">
            <!-- Bin Number -->
            <div class="col-md-6">
              <ValidationProvider name="Bin Number" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label for="binnumber">
                    Bin Number
                    <span class="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="binnumber"
                    v-model="newBin.binNumber"
                    class="form-control"
                    :class="{ 'is-invalid': errors[0] }"
                    placeholder="Enter Bin Number"
                    :readonly="editMode"
                  />
                  <span class="text-danger error-msg">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </div>
            <!-- Bank name -->
            <div class="col-md-6">
              <ValidationProvider name="Bank name" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label for="bankname">
                    Bank name
                    <span class="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="bankname"
                    v-model="newBin.bankName"
                    class="form-control"
                    :class="{ 'is-invalid': errors[0] }"
                    placeholder="Enter Bank name"
                  />
                  <span class="text-danger error-msg">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </div>
            <!-- Bank Brand Name -->
            <div class="col-md-6">
              <ValidationProvider name="Bank Brand name" v-slot="{ errors }">
                <div class="form-group">
                  <label for="brand">Bank Brand name</label>
                  <input
                    type="text"
                    id="brand"
                    v-model="newBin.bankBrandName"
                    class="form-control"
                    :class="{ 'is-invalid': errors[0] }"
                    placeholder="Enter Bank Brand name"
                  />
                  <span class="text-danger error-msg">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </div>
            <!-- Scheme -->
            <div class="col-md-6">
              <ValidationProvider name="Scheme name" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label for="scheme">
                    Scheme name
                    <span class="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="scheme"
                    v-model="newBin.scheme"
                    class="form-control"
                    :class="{ 'is-invalid': errors[0] }"
                    placeholder="Enter scheme name"
                  />
                  <span class="text-danger error-msg">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </div>
            <!-- Card Type -->
            <div class="col-md-6">
              <ValidationProvider
                name="Card Type name"
                rules="required"
                v-slot="{ errors }"
              >
                <div class="form-group">
                  <label for="cardType">
                    Card Type name
                    <span class="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="cardType"
                    v-model="newBin.cardType"
                    class="form-control"
                    :class="{ 'is-invalid': errors[0] }"
                    placeholder="Enter Card Type name"
                  />
                  <span class="text-danger error-msg">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </div>
            <!-- Card Level1 -->
            <div class="col-md-6">
              <ValidationProvider name="Card Level1" v-slot="{ errors }">
                <div class="form-group">
                  <label for="cardLevel1">Card Level1</label>
                  <input
                    type="text"
                    id="cardLevel1"
                    v-model="newBin.cardLevel1"
                    class="form-control"
                    :class="{ 'is-invalid': errors[0] }"
                    placeholder="Enter Card Level1"
                  />
                  <span class="text-danger error-msg">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </div>
            <!-- Card level2 -->
            <div class="col-md-6">
              <ValidationProvider name="Card Level2" v-slot="{ errors }">
                <div class="form-group">
                  <label for="cardLevel2">Card Level2</label>
                  <input
                    type="text"
                    id="cardLevel2"
                    v-model="newBin.cardLevel2"
                    class="form-control"
                    :class="{ 'is-invalid': errors[0] }"
                    placeholder="Enter Card Level2"
                  />
                  <span class="text-danger error-msg">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </div>
            <!-- Country Code -->
            <div class="col-md-6">
              <ValidationProvider
                name="Country Code"
                rules="required"
                v-slot="{ errors }"
              >
                <div class="country-dropdown">
                  <div
                    class="form-group form-select multiselect-grp"
                    :class="{
                      errors: errors[0],
                      success:
                        newBin.countryCode &&
                        newBin.countryCode.length != 0 &&
                        !errors[0],
                    }"
                  >
                    <span class="float-label">
                      <label for="card_country">Country*</label>
                      <multiselect
                        placeholder=""
                        v-model="newBin.countryCode"
                        :show-labels="false"
                        :options="countryList"
                        :searchable="true"
                        label="name"
                        track-by="countryid"
                      >
                        <template slot="option" slot-scope="props">
                          <span
                            :class="
                              'flag-icon flag-icon-' +
                              props.option.isoCode.toLowerCase() +
                              ' fi-md fi-round '
                            "
                          ></span>
                          <div class="option__desc">
                            <span class="option__title">
                              {{ props.option.countryname }}
                            </span>
                          </div>
                        </template>
                      </multiselect>
                      <i
                        class="fa fa-times"
                        v-if="errors.length && errors[0]"
                      ></i>
                      <i
                        class="fa fa-check"
                        v-if="
                          newBin.countryCode &&
                          newBin.countryCode.length != 0 &&
                          !errors[0]
                        "
                      ></i>
                    </span>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <!-- Is Whitelisted -->
            <div class="col-md-6">
              <ValidationProvider
                name="Is whitelisted?"
                rules="required"
                v-slot="{ errors }"
              >
                <div class="form-group">
                  <label for="roleid">
                    Is whitelisted?
                    <span class="text-danger">*</span>
                  </label>
                  <b-form-select
                    id="roleid"
                    v-model="newBin.isWhitelisted"
                    :options="whitelistedOptions"
                    class="form-control"
                    :class="{ 'is-invalid': errors[0] }"
                  >
                    <template #first>
                      <b-form-select-option :value="null" disabled>
                        -- Select Option --
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                  <span class="text-danger error-msg">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="d-flex justify-content-end mt-4">
            <b-button
              variant="outline-secondary"
              size="lg"
              class="mr-3"
              @click="hideModal"
              :disabled="isSubmitting"
            >
              Cancel
            </b-button>
            <b-button
              type="submit"
              variant="primary"
              size="lg"
              v-if="!editMode"
              :disabled="isSubmitting"
            >
              <span v-if="isSubmitting">
                <b-spinner small></b-spinner>
                Creating...
              </span>
              <span v-else>Create Bin</span>
            </b-button>
            <b-button
              type="submit"
              variant="primary"
              size="lg"
              v-if="editMode"
              :disabled="isSubmitting"
            >
              <span v-if="isSubmitting">
                <b-spinner small></b-spinner>
                Updating...
              </span>
              <span v-else>Update Bin</span>
            </b-button>
          </div>
        </form>
      </ValidationObserver>
    </b-modal>

    <main-loader :loading="isLoading"></main-loader>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { ISLOADING } from "../../../store/mutations.type";
const LoaderComponent = require("@/components/admin/loader/LoaderComponent.vue").default;
import { mapGetters } from "vuex";
import {
  GET_BIN_LIST,
  POST_BIN,
  GET_BIN_DETAILS,
  UPDATE_BIN,
  DELETE_BIN,
  COUNTRYLIST,
} from "../../../store/actions.type.js";
import { myFunction } from "@/common/common-helper.js";
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
  name: "BinComponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    Multiselect,
    "main-loader": LoaderComponent,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      breadCrumbIteams: [
        {
          title: "Bin",
          links: "",
        },
        {
          title: "Bin List",
          links: "",
        },
      ],
      search_keywords: "",
      exportcsv: false,
      isVisibleFilter: false,
      filterField: [
        { id: "scheme", name: "Scheme", $isDisabled: false },
        { id: "type", name: "Type", $isDisabled: false },
        { id: "level", name: "Level", $isDisabled: false },
        { id: "is_whitelisted", name: "Is Whitelisted", $isDisabled: false },
      ],
      advanceFilters: [{ field: null, search: "" }],
      displayFilters: [],
      items: [],
      fields: [
        { key: "binNumber", label: "Bin", sortable: true },
        { key: "bankName", label: "Bank Name", sortable: true },
        { key: "bankBrand", label: "Bank Brand", sortable: true },
        { key: "scheme", label: "Scheme", sortable: true },
        { key: "type", label: "Type", sortable: true },
        { key: "level1", label: "Level1", sortable: true },
        { key: "level2", label: "Level2", sortable: true },
        { key: "country", label: "Country", sortable: true },
        { key: "whitelisted", label: "Whitelisted?", sortable: true },
        { key: "action", label: "Action" },
      ],
      totalRows: 1,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 10,
      pageOptions: [10, 20, 50, 100, { value: 1000, text: 1000 }],
      sortBy: "createdAt",
      sortDesc: true,
      sortDirection: "asc",

      // Add Bin modal state
      showAddBin: false,
      modaltitle: "",
      editMode: false,
      selectbinid: "",
      isSubmitting: false,
      apiError: null,
      newBin: {
        binNumber: "",
        bankName: "",
        bankBrandName: "",
        scheme: "",
        cardType: "",
        cardLevel1: "",
        cardLevel2: "",
        countryCode: "",
        paymentGateway: "",
        isWhitelisted: null,
      },
      whitelistedOptions: [
        { value: "Yes", text: "Yes" },
        { value: "No", text: "No" },
      ],
    };
  },
  methods: {
    searchBin() {
      // Implement search logic
      this.$store.commit(ISLOADING, true);
      this.getBinList();
    },
    // Right side header buttons
    async showAddBinModal() {
      if (!this.countryList || this.countryList.length === 0) {
        this.$store.commit(ISLOADING, true);
        try {
          await this.$store.dispatch(COUNTRYLIST);
        } catch (error) {
          console.error("Error loading country list:", error);
        } finally {
          this.$store.commit(ISLOADING, false);
        }
      }

      this.modaltitle = "Add Bin";
      this.editMode = false;
      this.resetForm();
      this.showAddBin = true;
    },
    hideModal() {
      this.showAddBin = false;
    },
    resetForm() {
      this.isSubmitting = false;
      this.newBin = {
        binNumber: "",
        bankName: "",
        bankBrandName: "",
        brandName: "",
        cardType: "",
        cardLevel1: "",
        cardLevel2: "",
        countryCode: "",
        paymentGateway: "",
        isWhitelisted: null,
      };
    },
    async submitForm() {
      if (this.editMode) {
        await this.updateBin();
      } else {
        await this.addBin();
      }
    },
    async addBin() {
      this.isSubmitting = true;
      try {
        const payload = {
          bin: this.newBin.binNumber,
          bank: this.newBin.bankName,
          bank_brand: this.newBin.bankBrandName,
          scheme: this.newBin.scheme,
          type: this.newBin.cardType,
          level1: this.newBin.cardLevel1,
          level2: this.newBin.cardLevel2,
          country: this.newBin.countryCode.countryid,
          is_whitelisted: this.newBin.isWhitelisted,
        };

        const response = await this.$store.dispatch(POST_BIN, payload);

        if (response.data && response.data.code === "1007-000") {
          myFunction.showInfo("Bin added successfully.", "success");
          this.resetForm();
          this.showAddBin = false;
          this.$store.commit(ISLOADING, true);
          this.getBinList();
        } else {
          const errorMessage =
            response.data?.message || "Failed to create user role. Please try again.";
          const errorDetail = response.data?.detail;
          this.apiError = errorDetail ? `${errorMessage}: ${errorDetail}` : errorMessage;
          myFunction.showInfo(this.apiError, "error");
        }
      } catch (error) {
        this.isSubmitting = false;
        console.error("Error adding bin:", error);
        const errorMessage =
          error.response?.data?.message ||
          "An error occurred while creating the user. Please try again.";
        const errorDetail = error.response?.data?.detail;
        this.apiError = errorDetail ? `${errorMessage}: ${errorDetail}` : errorMessage;
        myFunction.showInfo(this.apiError, "error");
      }
    },
    downloadCsv() {
      // Simple CSV download of current table items
      this.exportcsv = true;
      this.$store.commit(ISLOADING, true);
      this.getBinList();
    },
    copyText(data, type) {
      var m = document;
      data = m.createTextNode(data);
      var w = window;
      var b = m.body;
      var d = {};
      b.appendChild(data);
      d = m.createRange();
      var g = w.getSelection;
      d.selectNodeContents(data);
      g().removeAllRanges();
      g().addRange(d);
      m.execCommand("copy");
      g().removeAllRanges();
      data.remove();
      myFunction.showInfo(`${type} Copied`, "success");
    },
    onSortChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      if (this.sortBy != "") {
        this.$store.commit(ISLOADING, true);
        this.getBinList();
      }
    },
    getCurrentDateFileSuffix() {
      const now = new Date();

      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0"); // 01-12
      const day = String(now.getDate()).padStart(2, "0"); // 01-31

      return `${year}${month}${day}`; // e.g. "20251124"
    },
    async getBinList() {
      let page = "";
      let page_size = "";
      let sortby = "";
      let sort = false;
      if (this.currentPage != undefined) {
        page = this.currentPage;
      } else {
        page = 1;
      }
      if (this.perPage != undefined) {
        page_size = this.perPage;
      } else {
        page_size = 10;
      }
      if (this.sortBy == "") {
        sortby = "created_at";
      } else if (this.sortBy == "bin") {
        sortby = "bin";
      } else {
        sortby = this.sortBy;
      }
      if (this.sortDesc == true) {
        sort = "desc";
      } else {
        sort = "asc";
      }

      this.currentPageJump = page;

      let tempparam = `?sort=${sort}&sortby=${sortby}&limit=${page_size}&page=${page}`;
      if (this.search_keywords) {
        tempparam = tempparam + `&search=${this.search_keywords.trimStart()}`;
      }
      if (this.exportcsv) {
        tempparam = tempparam + `&export=true&format=csv`;
      }
      if (this.displayFilters && this.displayFilters.length > 0) {
        this.displayFilters.map((item) => {
          tempparam = tempparam + `&${item.filter_field}=${item.filter_value}`;
        });
      }

      const response = await this.$store.dispatch(GET_BIN_LIST, tempparam);
      if (this.exportcsv) {
        this.exportcsv = false;
        this.$store.commit(ISLOADING, false);
        if (response.status == 200) {
          const blob = new Blob([response.data], {
            type: "text/csv;charset=utf-8;",
          });
          const link = document.createElement("a");
          const url = URL.createObjectURL(blob);
          const dateSuffix = this.getCurrentDateFileSuffix();
          link.setAttribute("href", url);
          link.setAttribute("download", `bin_list_${dateSuffix}.csv`);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          myFunction.showInfo("Failed to download CSV. Please try again.", "error");
        }
        return;
      } else {
        this.items = [];
        const tempitems = [];
        if (response.status == 200) {
          response.data.details.map((item) => {
            tempitems.push({
              id: item.id,
              binNumber: item.bin,
              bankName: item.bank,
              bankBrand: item.bankBrand,
              scheme: item.scheme,
              type: item.type,
              level1: item.level1,
              level2: item.level2,
              country: item.country,
              whitelisted: item.isWhitelisted == true ? "Yes" : "No",
            });
          });
          this.items = tempitems;
          this.totalRows = response.data.query.total;
        }
      }
    },
    openFilters() {
      // When opening filters, if no filters exist yet, initialize with first field
      if (this.advanceFilters.length === 0 || !this.advanceFilters[0].field) {
        const firstField = this.filterField[0];
        if (firstField) {
          // Reset all disabled flags
          this.filterField.forEach((f) => {
            f.$isDisabled = false;
          });
          // Disable first field as it's being used
          firstField.$isDisabled = true;
          // Initialize first filter row with first field and empty search
          this.advanceFilters = [
            {
              field: firstField,
              search: "",
            },
          ];
        }
      }
      this.isVisibleFilter = !this.isVisibleFilter;
    },
    appendFilter() {
      const available = this.filterField.find((f) => !f.$isDisabled);
      if (available) {
        this.advanceFilters.push({ field: available, search: "" });
        available.$isDisabled = true;
      }
    },
    fieldsUpdate() {
      this.filterField.forEach((item) => {
        item.$isDisabled = false;
      });
      this.advanceFilters.forEach((item) => {
        if (item.field && item.field.id) {
          this.filterField.find((f) => f.id === item.field.id).$isDisabled = true;
        }
      });
    },
    removeFilter(idx) {
      const removed = this.advanceFilters[idx];
      if (removed && removed.field && removed.field.id) {
        const field = this.filterField.find((f) => f.id === removed.field.id);
        if (field) field.$isDisabled = false;
      }
      this.advanceFilters.splice(idx, 1);
      // Also keep displayFilters in sync when removing from popup list directly
      if (this.displayFilters && this.displayFilters.length > idx) {
        this.displayFilters.splice(idx, 1);
      }
    },
    // Remove pill from inline filter list (and from params)
    removeDisplayFilter(index) {
      // Remove from displayFilters
      this.displayFilters.splice(index, 1);
      // Rebuild advanceFilters from remaining displayFilters so popup matches
      this.advanceFilters = this.displayFilters.map((df) => {
        const field = this.filterField.find((f) => f.id === df.filter_field);
        return {
          field,
          search: df.filter_value,
        };
      });
      // Enable/disable options based on active filters
      this.fieldsUpdate();
      // Reset to first page and reload list with updated params
      this.currentPage = 1;
      this.$store.commit(ISLOADING, true);
      this.getBinList();
    },
    applyTestfilter() {
      // Build displayFilters from advanceFilters and trigger list reload
      this.displayFilters = this.advanceFilters
        .filter((f) => f.field && f.search)
        .map((f) => ({
          filter_field: f.field.id,
          field_name: f.field.name,
          filter_value: f.search,
        }));
      this.isVisibleFilter = false;
      this.currentPage = 1;
      this.$store.commit(ISLOADING, true);
      this.getBinList();
    },
    clearALLfilter() {
      // Reset field disable states
      this.filterField.forEach((item) => {
        item.$isDisabled = false;
      });
      // Initialize first filter with first option selected (like CustomerListComponent)
      const firstField = this.filterField[0] || null;
      if (firstField) {
        firstField.$isDisabled = true;
      }
      this.advanceFilters = [
        {
          field: firstField,
          search: "",
        },
      ];
      this.displayFilters = [];
      this.isVisibleFilter = false;
      this.currentPage = 1;
      this.$store.commit(ISLOADING, true);
      this.getBinList();
    },
    async editBin(data) {
      // Implement edit logic
      this.modaltitle = "Edit Bin";
      this.editMode = true;
      this.selectbinid = data.id;

      // Ensure countryList is loaded before trying to match country in details
      if (!this.countryList || this.countryList.length === 0) {
        this.$store.commit(ISLOADING, true);
        try {
          await this.$store.dispatch(COUNTRYLIST);
        } catch (error) {
          console.error("Error loading country list:", error);
        } finally {
          this.$store.commit(ISLOADING, false);
        }
      }

      await this.getBinDetails(this.selectbinid);
      this.showAddBin = true;
    },
    async getBinDetails(binid) {
      const response = await this.$store.dispatch(GET_BIN_DETAILS, binid);
      if (response.data.code === "1007-000") {
        this.newBin.binNumber = response.data.details.bin;
        this.newBin.bankName = response.data.details.bank;
        this.newBin.bankBrandName = response.data.details.bankBrand;
        this.newBin.scheme = response.data.details.scheme;
        this.newBin.cardType = response.data.details.type;
        this.newBin.cardLevel1 = response.data.details.level1;
        this.newBin.cardLevel2 = response.data.details.level2;
        // Normalize country value to the countryList object so Multiselect can match it
        const countryVal = response.data.details.country;
        let matchedCountry = null;
        if (countryVal) {
          if (typeof countryVal === "object") {
            // If API returned an object, try to match by common id/name fields, fallback to the object
            matchedCountry =
              this.countryList.find((c) =>
                c.countryid == countryVal.countryid ||
                c.countryid == countryVal.id ||
                c.countryname == countryVal.countryname ||
                c.name == countryVal.name,
              ) || countryVal;
          } else {
            // If API returned a primitive (id or name), try to find the corresponding object
            matchedCountry =
              this.countryList.find((c) =>
                String(c.countryid) === String(countryVal) ||
                c.countryname === countryVal ||
                c.name === countryVal ||
                c.isocode === countryVal,
              ) || null;
          }
        }
        this.newBin.countryCode = matchedCountry;
        this.newBin.isWhitelisted = response.data.details.isWhitelisted;

        myFunction.showInfo("Successfully fetch Bin Details", "info");
      }
    },
    async updateBin() {
      this.isSubmitting = true;
      const params = {
        id: this.selectbinid,
        bank: this.newBin.bankName,
        bank_brand: this.newBin.bankBrandName,
        scheme: this.newBin.scheme,
        type: this.newBin.cardType,
        level1: this.newBin.cardLevel1,
        level2: this.newBin.cardLevel2,
        country: this.newBin.countryCode.countryid,
        is_whitelisted: this.newBin.isWhitelisted,
      };
      this.$store
        .dispatch(UPDATE_BIN, params)
        .then((response) => {
          if (response.status == 200) {
            myFunction.showInfo(response.data.message, "success");
            this.resetForm();
            this.showAddBin = false;
            this.$store.commit(ISLOADING, true);
            this.getBinList();
          } else {
            this.isSubmitting = false;
            myFunction.showInfo(response.data.message, "error");
          }
        })
        .catch((error) => {
          console.error("Error updating bin:", error);
          this.isSubmitting = false;
          myFunction.showInfo(
            "An error occurred while updating the bin. Please try again.",
            "error"
          );
        });
    },
    deleteBin(data) {
      // Implement delete logic
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You want to delete this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            let params = data.id;
            this.$store
              .dispatch(DELETE_BIN, params)
              .then((response) => {
                if (response.status == 200) {
                  myFunction.showInfo(response.data.message, "success");
                  this.$store.commit(ISLOADING, true);
                  this.getBinList();
                } else {
                  myFunction.showInfo(response.data.message, "error");
                }
              })
              .catch((error) => {
                console.error("Error deleting bin:", error);
                myFunction.showInfo(
                  "An error occurred while deleting the bin. Please try again.",
                  "error"
                );
              });
          }
        });
    },
    onEnter(e) {
      const paginationMenu = Math.ceil(this.totalRows / this.perPage);
      if (e.target.value > 0) {
        if (paginationMenu >= e.target.value) {
          this.currentPage = this.currentPageJump = Number(e.target.value);
        } else {
          this.currentPage = this.currentPageJump = paginationMenu;
        }
      } else {
        this.currentPage = this.currentPageJump = 1;
      }
    },
  },
  async mounted() {
    this.$store.commit(ISLOADING, true);
    await this.getBinList();
  },
  watch: {
    displayFilters() {
      if (
        this.$cookies.get("remitter-list-filter") != null &&
        this.displayFilters.length > 0
      ) {
        this.$store.commit(ISLOADING, true);
        this.getBinList();
      }
    },
    currentPage: {
      handler: function () {
        this.$store.commit(ISLOADING, true);
        this.getBinList();
      },
    },
    perPage: {
      handler: function () {
        this.$store.commit(ISLOADING, true);
        this.getBinList();
      },
    },
  },
  computed: {
    ...mapGetters(["countryList", "isLoading"]),
  },
};
</script>

<style scoped>
.table-custom th,
.table-custom td {
  vertical-align: middle;
}
.text-success {
  color: green;
}
.text-danger {
  color: red;
}
</style>
